/* eslint-disable*/
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import array from 'core-js'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})


export default new Vuex.Store({
  state: {
    orderDetails: {
      startDate : null,
      endDate : null,
    },
    selectedProduct: {},
    cartContent: [],
    locale: null,
    productList: {
      rental: [],
      purchase: []
    },
    managedItem: null,
    managedRental:null,
    userAccessToken: null,
    adminAccessToken: null,
    availableProducts: [],
    lastFetchedProductList: null,
    showLoginDialog: false,
    isLoggedIn: true,
    productViewKey: null,
  },
  mutations: {
    SET_PRODUCTLIST(state, payload) {
      state.productList = payload;
    },
    SET_RENTAL_PRODUCTS(state, payload) {
      state.productList.rental = payload;
    },
    SET_PURCHASE_PRODUCTS(state, payload) {
      state.productList.purchase = payload;
    },
    SET_USER_TOKEN(state, payload) {
      state.userAccessToken = payload.userAccessToken
    },
    SET_ADMIN_TOKEN(state, payload) {
      state.adminAccessToken = payload.adminAccessToken
    },
    LOGOUT_USER(state,payload){
      state.userAccessToken = payload.userAccessToken  
    },
    LOGOUT_ADMIN(state){
      state.adminAccessToken = null
    },
    SET_AVAILABLE_PRODUCTS(state, payload) {
      state.availableProducts = payload
    },
    SET_ORDERDATE_START(state,payload){
      state.orderDetails.startDate = payload
    },
    SET_ORDERDATE_END(state,payload){
      state.orderDetails.endDate = payload
    },
    CLEAR_ORDERDATE_START(state){
      state.orderDetails.startDate = null
    }, 
    CLEAR_ORDERDATE_END(state) {
      state.orderDetails.endDate = null
    },
    SET_LASTFETCHED_DATE(state, payload) {
      state.lastFetchedProductList = payload
    },
    SET_LOCALE(state,payload) {
      state.locale = payload 
    },
    SET_PRODUCT_VIEW_KEY(state,payload){
      state.productViewKey = payload
    },
    ADD_PRODUCT_TO_CART(state, payload){
      const existingProduct = state.cartContent.find(item => item.product.serialNumber === payload.serialNumber);
      if(existingProduct){
        if(payload.amount !== 1){
          existingProduct.amount += payload.amount
        } else{
        existingProduct.amount += 1
        }
      } else{
        let amount = payload.amount ? payload.amount : 1
        var product = {
          product: payload,
          amount: amount,
        }
        state.cartContent.push(product)
      }
      $snackbar.add({
        type: 'success',
        text: payload.snackBarText
      });
    },
    SET_PRODUCT_AVAILABILITY_FOR_PERIOD(state, payload) {
      const product = state.productList.rental?.find(p => p.serialNumber === payload.serialNumber);
      if (product) {
        product.availableQuantityForPeriod = payload.availableQuantityForPeriod;
      }
    },
    INCREMENT_PRODUCT_AMOUNT(state,payload) {
      state.cartContent[payload].amount += 1
    },
    DECREMENT_PRODUCT_AMOUNT(state,payload){
      state.cartContent[payload].amount -= 1
    },
    SET_PRODUCT_AMOUNT(state,payload){
      state.cartContent[payload.index].amount = payload.amount
    },
    REMOVE_PRODUCT_FROM_CART(state,payload){
      state.cartContent.splice(payload.productIndex,1)
      $snackbar.add({
        type: 'warning',
        text: payload.snackBarText
      });
    },
    EMPTY_CART(state,payload){
      state.cartContent = []
      $snackbar.add({
        type: 'warning',
        text: payload.snackBarText
      });
    },
    SET_SELECTED_PRODUCT(state,payload){
      state.selectedProduct = payload
    },
    CLEAR_SELECTED_PRODUCT(state){
      state.selectedProduct = {}
    },
    SET_IS_LOGGED_IN(state,payload){
      state.isLoggedIn = payload
    },
    SET_SHOW_LOGIN_DIALOG(state,payload){
      state.showLoginDialog = payload
    },
    SET_MANAGED_ITEM(state,payload){
      state.managedItem = payload
    },
    SET_MANAGED_RENTAL(state,payload){
      state.managedRental = payload
    },
    UPDATE_CART_ELEMENT(state, payload) {
      state.cartContent[payload.index].product.price = payload.price;
      state.cartContent[payload.index].product.deposit = payload.deposit;
      state.cartContent[payload.index].product.upsaleProducts = payload.upsaleProducts;
    }
  },
  methods: {
  },
  getters: {
    lastFetchedProductList(state) {
      return this.$store.lastFetchedProductList
    },
    getUserAccesstoken(state) {
      return state.userAccessToken
    },
    getAdminAccessToken(state) {
      return state.adminAccessToken
    },
    getStartDate(state){
      return state.orderDetails.startDate
    },
    getEndDate(state){
      return state.orderDetails.endDate
    },
    getSelectedProduct(state){
      return state.selectedProduct
    },
    getIsLoggedIn(state){
      return state.isLoggedIn
    },
    getShowLoginDialog(state){
      return state.showLoginDialog
    },
    getAvailableProducts(state){
      return state.availableProducts;
    },
    getProductAvailability: (state) => (serialNumber) => {
      const product = state.productList?.find(p => p.serialNumber === serialNumber);
      return product?.availableQuantityForPeriod ?? 0;
    }
    
  },
  plugins: [vuexLocal.plugin],
})
